import axios from 'axios'

export default {
    get(npi, fields, referralPoolId) {
        const _fields = (fields || ['firstName', 'middleName', 'lastName', 'email', 'phone']).join(',')
        const params = { _fields, referralPoolId }

        return axios.get(`unauthenticated/provider-database/${npi}`, { params })
    },

    search(searchParams) {
        return axios.get(`unauthenticated/provider-database/search`, {
            params: searchParams || {},
        })
    },
}
